import React from 'react';

const vocoContext = React.createContext(
    {
    "ATTRIBUTES": {
        "id": 72163,
        "attach": null,
        "cid": 1292,
        "status": "received",
        "validFrom": "2021-03-31T23:00:00.000Z",
        "validTo": "2021-12-31T22:59:00.000Z",
        "historyValidTo": null,
        "dtRedeemed": null,
        "origin": null,
        "codeCountNotLimited": true,
        "messageClassName": "Campaign.CxImmediateReward"
    },
    "id": 6160,
    "title": "Savings Objective",
    "extendedType": null,
    "extendedData": null,
    "markedUp": "<p>We can help! Did you know 45% of RF customers who are saving and putting it towards a college fund.</p>",
    "plainText": "",
    "className": "Campaign.CxImmediateReward",
    "data": "",
    "terms": "",
    "Id": 1292,
    "name": "AudiencePoll::E1359B08D742496FB149C4997850F809",
    "schemeId": 117,
    "messageId": 6160,
    "validFrom": "2021-03-31T23:00:00.000Z",
    "validTo": "2021-12-31T22:59:00.000Z",
    "radicalValue": 0,
    "selectionQuery": "",
    "category": " SPE:Message",
    "subCategory": "",
    "bannerValue": "<div style='-webkit-transform: scale(1.1);margin-left:10px;margin-right:-10px;'><b style='color:#997777'></b> </div>",
    "links": [
        ""
    ],
    "offerImage": "https://demo-use2-app.vocohub.com/_/gtp//pic-upload/SST/117/3256/0/1ac6d8b9856f534d56bf072af1430e36.png",
    "heroImage": "undefined.jpg",
    "locationIDs": "",
    "quantities": {
        "unlockables": "",
        "unlockedBy": [],
        "rewards": [
            {
                "type": "sendinstant",
                "sortType": "Messaging",
                "realType": "sendinstant",
                "icon": "envelope_114.png",
                "desc": "Send Instant Message",
                "caption": "Send Message '||definition.parameters[0].value||'",
                "definition": {
                    "desc": "Send an instant message to the user",
                    "max": 0,
                    "minDays": 0,
                    "parameters": [
                        {
                            "name": "message",
                            "value": "Test",
                            "desc": "Message to send",
                            "type": "text",
                            "index": 0
                        },
                        {
                            "name": "title",
                            "value": "Test",
                            "desc": "The title of the instant message box",
                            "type": "text",
                            "index": 1
                        },
                        {
                            "name": "caption",
                            "value": "Ok",
                            "desc": "The caption of the close button",
                            "type": "text",
                            "index": 2
                        },
                        {
                            "name": "image",
                            "value": "",
                            "desc": "Image to display",
                            "type": "picture",
                            "index": 3
                        }
                    ],
                    "guid": "ED5EC441BCE8465CAC95BDA51603423B",
                    "earliest": "2021-04-22T08:51:06.500Z"
                },
                "guid": "ED5EC441BCE8465CAC95BDA51603423B",
                "values": {
                    "3256::Continue": {
                        "value": {
                            "id": "Action",
                            "name": "Action"
                        },
                        "outcome": {
                            "id": "3256::Continue",
                            "value": "Continue"
                        }
                    }
                }
            }
        ],
        "amounts": [],
        "sendToNoOne": "false",
        "files": "",
        "reserved": {},
        "pushDeal": false,
        "enableNewFlagging": true,
        "enableHotFlagging": true,
        "enableRunningOutFlagging": true,
        "enableBanner": false,
        "subCategoryBanner": false,
        "optimiseBanner": true,
        "targetBanner": false,
        "automaticPriority": true,
        "spend": false,
        "spendAmount": 0,
        "playNear": false,
        "playIn": false,
        "availablePush": false,
        "nearByPrepend": "NEARBY:",
        "push": "",
        "manualPriority": 100,
        "override": 0,
        "bannerTitle": "",
        "bannerDescription": "",
        "redemptionMessage": "",
        "maximum": 500,
        "maximumPerDevice": 1,
        "buttons": [
            {
                "$_type": "Button",
                "caption": "Continue",
                "color": "",
                "important": false,
                "icon": "",
                "close": "true",
                "value": "Continue",
                "type": "default",
                "complex": false,
                "list": [],
                "location": false,
                "defaultTitle": "",
                "hyperlink": {
                    "options": {
                        "height": 500,
                        "width": 500
                    },
                    "target": "popup"
                },
                "index": 0
            },
            {
                "$_type": "Button",
                "caption": "Skip",
                "color": "",
                "important": false,
                "icon": "",
                "close": "true",
                "value": "Skip",
                "type": "default",
                "complex": false,
                "list": [],
                "location": false,
                "defaultTitle": "",
                "hyperlink": {
                    "options": {
                        "height": 500,
                        "width": 500
                    },
                    "target": "popup"
                },
                "index": 1
            }
        ],
        "extras": {
            "bookUrl": "",
            "buyNowUrl": "",
            "bookUrlTitle": "",
            "buyNowUrlTitle": ""
        },
        "voucher": {
            "expiry": "2021-04-21T21:59:00.000Z",
            "type": "Info Only",
            "validHours": 168,
            "prefix": "DBS"
        },
        "gamesOnly": false,
        "onlineOffers": false,
        "checkoutUrl": "",
        "barcode": "",
        "barcodeType": "",
        "validityHours": "",
        "emailCampaignId": "",
        "values": {
            "$_type": "ValueProducer",
            "values": {
                "Action": {
                    "$_type": "Value",
                    "name": "Action",
                    "id": "Action",
                    "outcomes": [
                        {
                            "id": "3256::Continue",
                            "value": "Continue"
                        },
                        {
                            "id": "3256::Skip",
                            "value": "Skip"
                        }
                    ]
                }
            },
            "method": "getValues",
            "hasValues": true,
            "event": "change",
            "$uniqueID": 1348
        },
        "showFullScreenMessage": false,
        "hideWhenRedeemed": true,
        "showCoreImage": true
    },
    "publishFrom": "2021-04-20T23:00:00.000Z",
    "publishTo": "2021-04-21T21:59:00.000Z",
    "popularitySortOrder": 100,
    "numDays": null,
    "banner": 0,
    "optimise": 1,
    "priority": 100,
    "bannerTargeted": 0,
    "locationPush": 0,
    "availablePush": 0,
    "beaconPush": 1,
    "pushMessage": "",
    "bannerPriority": 100,
    "subCategoryBanner": 0,
    "mapp_id": 3256,
    "isGlobal": true,
    "systemId": 3256,
    "categories": {
        "": true,
        "spe:message": true
    }
}
)

export default vocoContext;
